import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import genieLogo from "../assets/genie-logo.png";
import {
  LayoutDashboard,
  Clock,
  Cpu,
  MapPin,
  FileText,
  AlertTriangle,
  Zap,
  Search,
  ArrowUpRightSquare,
  ShieldAlert,
  UserCog,
  Settings,
  History
} from "lucide-react";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItem = (label, path, Icon) => (
    <div
      key={path}
      onClick={() => navigate(path)}
      style={{
        padding: "1rem",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
        borderBottom: "1px solid #ccc",
        fontWeight: "bold",
        backgroundColor: location.pathname === path ? "#e0eaff" : "transparent",
        borderLeft: location.pathname === path ? "5px solid #007bff" : "5px solid transparent",
      }}
    >
      <Icon size={18} />
      {label}
    </div>
  );

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      localStorage.removeItem("meterGenieUser");
      localStorage.removeItem("token");
      window.location.href = "/";
    }
  };

  return (
    <div
      style={{
        width: "220px",
        background: "#f5f5f5",
        height: "100vh",
        boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflowY: "auto",
      }}
    >
      <div style={{ flexGrow: 1 }}>
        <div style={{ padding: "1rem", textAlign: "center" }}>
          <img src={genieLogo} alt="Meter Genie" style={{ width: "80px", marginBottom: "0.5rem" }} />
          <div style={{ fontWeight: "bold", fontSize: "1.2rem" }}>Meter Genie</div>
        </div>

        {navItem("Dashboard", "/dashboard", LayoutDashboard)}
        {navItem("Interval Data", "/intervals", Clock)}
        {navItem("Devices", "/devices", Cpu)}
        {navItem("Map", "/map", MapPin)}
        {navItem("Reports", "/reports", FileText)}
        {navItem("Alerts", "/alerts", AlertTriangle)}
        {navItem("Blink History", "/blinks", Zap)}
        {navItem("Blink Analyzer", "/blink-analyzer", Search)}
        {navItem("Ping History", "/ping-history", ArrowUpRightSquare)}
        {navItem("Interval History", "/interval-history", History)}
        {navItem("Fault Zones", "/fault-zones", ShieldAlert)}
        {navItem("Users", "/users", UserCog)}
        {navItem("Settings", "/settings", Settings)}
      </div>

      <div style={{ padding: "1rem", borderTop: "1px solid #ccc" }}>
        <button
          onClick={handleLogout}
          style={{
            width: "100%",
            padding: "0.5rem",
            background: "#d9534f",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            fontWeight: "bold",
          }}
        >
          Log Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
